<template>
    <div id="modal-new-note" class="modal-dialog modal-lg">
        <div class="modal-content">
            <header class="modal-header">
                <a class="h3" @click="$emit('mode', 'list')">
                    <!-- TODO extract svg -->
                    <svg width="16px" height="17px" viewBox="0 0 16 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Android-APP-wireframes" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="4_inspirace-detail" transform="translate(-20.000000, -44.000000)" fill="#5937B7"><g id="Top-Bar/Back-Icon"><polygon id="back-arrow" points="36 51.20625 23.8 51.20625 29.4 45.50125 28 44.075 20 52.225 28 60.375 29.4 58.94875 23.8 53.24375 36 53.24375"></polygon></g></g></g></svg>

                    {{ __('Notes') }}
                </a>

                <button aria-hidden="true" class="close" type="button" @click="$emit('mode', 'list')">
                    <svg-icon icon="close-modal" />
                </button>
            </header>
            <div class="modal-body">
                <div class="note-form">
                    <h3>{{ __('New note') }}</h3>

                    <form action="#" method="POST" novalidate @submit.prevent="submit">
                        <form-input-type-text
                            name="name"
                            :label="__('Name')"
                            :errors="errors.name"
                            required
                            margin-bottom-double
                        ></form-input-type-text>

                        <form-input-type-text-area
                            name="body"
                            :label="__('Note')"
                            :errors="errors.body"
                            auto-grow
                            required
                            margin-bottom-double
                        ></form-input-type-text-area>

                        <div class="note-alert">
                            <div class="input-wrapper form-input-checkbox form-input-checkbox--lg">
                                <input id="alert" type="checkbox" name="alert" v-model="hasAlertDate"> 
                                <label for="alert">{{ __('Add a reminder to a note') }}</label>
                            </div>

                            <form-input-type-datepicker
                                v-if="hasAlertDate"
                                name="date"
                                :label="__('Date of reminder')"
                                :value="moment().add(1, 'days').format('YYYY-MM-DD').toString()"
                            ></form-input-type-datepicker>
                        </div>

                        <div class="btn-group">
                            <VButton :label="__('Save note')" type="submit" size="lg" position="center" />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        patientId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            form: {
                name: null,
                body: null,
                date: null,
                coachId: null
            },
            errors: {},
            hasAlertDate: false
        }
    },
    methods: {
        async submit(event) {
            const data = new FormData(event.target)

            const coachId = this.user.impersonator ? this.user.impersonator.coach_id : this.user.coach_id

            data.set('coach_id', coachId)

            if (!this.hasAlertDate) {
                data.delete('date')
            } else {
                if (data.get('date') == null || !(moment(data.get('date')).isValid())) {
                    data.set('date', moment().add(1, 'days').format('YYYY-MM-DD'))
                }
            }
            const rolePrefix = this.user.role === 'coach' ? 'coaches' : 'doctors'

            await axios.post(`/${rolePrefix}/patients/${this.patientId}/notes`, data)
                .then((e) => {
                    this.$emit('created', e.data)

                    $('#modal-note-new').modal('hide')
                })
                .catch((e) => {
                    console.log(e.response)
                    this.errors = e.response.data.errors
                })

            Vuemit.fire('Button--sending-failed', true)
        }
    }
}
</script>
